//@flow
export { CUSTOMER_TYPE_TRADE as TRADE } from '../src/authModal/authentication/userStorageConstants';
export { CUSTOMER_TYPE_VIP as VIP } from '../src/authModal/authentication/userStorageConstants';
export {
    CUSTOMER_TYPE_CONSUMER as CONSUMER,
} from '../src/authModal/authentication/userStorageConstants';
